import { render, staticRenderFns } from "./IBIContentPage.vue?vue&type=template&id=1d2f2e97&scoped=true"
import script from "./IBIContentPage.vue?vue&type=script&lang=js"
export * from "./IBIContentPage.vue?vue&type=script&lang=js"
import style0 from "./IBIContentPage.vue?vue&type=style&index=0&id=1d2f2e97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f2e97",
  null
  
)

export default component.exports